import Vue from 'vue'
import App from './App.vue'
// Vue Router
import router from '@/router'
// Vuex Store
import store from '@/store'
// Global Constants
import constants from '@/constants'

import '@/components/common-ui'

// ========================================
//
// Setup Add
//
// ========================================
// axios Add
import axios from './setup/axios-setup'
// Multi Language Add
import { i18n } from './setup/i18n-setup'

// Apollo Add
import { apolloProvider } from './setup/apollo-setup'
// Form Validation Add
import '@/setup/vee-validate-setup'
// Global Components Add
import '@/setup/global-components-setup'
// Theme Add
import '@/setup/theme-setup'
// Vuexy Admin Filters
import '@/setup/filters-setup'
// import global methods and data
import '@/setup/mixin-setup'
// import prototype
import '@/setup/prototype'

Vue.config.productionTip = false
Vue.config.devtools = false
Vue.prototype.$http = axios
Vue.prototype.constants = constants


const vm = new Vue({
  i18n,
  apolloProvider,
  router,
  store,
  render: h => h(App)
}).$mount('#app')


export default vm
